import { ModalRef } from './modal-ref.model';

export interface ModalSearchTagForm {
  ouvrage: string;
  tag: string;
  unite: string;
  tagDescription: string;
  ville: string;
  territoire: string;
  ouvrageDescription: string;
}

export abstract class Modal {
  modalInstance: ModalRef;

  abstract onInjectInputs(inputs: any): void;

  close(output?: any): void {
    this.modalInstance.close(output);
  }

  dismiss(output?: any): void {
    this.modalInstance.dismiss(output);
  }
}
